<div mat-dialog-title>{{ title }}</div>
<div mat-dialog-content>{{ description }}</div>
<div mat-dialog-actions class="flex-end" *ngIf="closeText">
  <button mat-button cdkFocusInitial mat-dialog-close>{{ closeText }}</button>
</div>
